<p-dialog
  header="Personel Seçin"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '450px' }"
  [contentStyle]="{ 'padding':'0', 'display':'flex', 'flex-direction':'column' }">

  <div class="p-3">
    <!-- Görev Çoklu Seçim Dropdown -->
    <label>Görev</label>
    <p-multiSelect
      [options]="positions"
      [(ngModel)]="selectedPositions"
      optionLabel="label"
      optionValue="value"
      placeholder="Tüm Görevler"
      (onChange)="onPositionChange()">
    </p-multiSelect>

    <!-- İsim / Soyisim Arama -->
    <label class="mt-2">İsim / Soyisim Ara</label>
    <input
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="searchTerm"
      (input)="onSearchChange()"
      placeholder="Ara...">
  </div>

  <div class="table-container" style="flex: 1; display: flex; flex-direction: column; min-height: 0;">
    <div class="table-header d-flex p-2" style="background:#1e88e5; color:white; border-radius:8px; flex-shrink: 0;">
      <div class="col-12 fw-bold">Personel</div>
    </div>

    <!-- Liste - Scroll sadece burada -->
    <div class="table-body mt-2" style="overflow-y: auto; flex: 1; max-height: 300px;">
      <div
        *ngFor="let staff of filteredStaffList"
        class="table-row d-flex align-items-center p-2"
        style="border-bottom: 1px solid #e1e1e1; cursor:pointer;"
        (click)="onSelectUser(staff.value)"
        [ngStyle]="{ 'background': selectedUserId === staff.value ? '#e0f3ff' : 'white' }">
        <div class="col-12 fw-bold">{{ staff.label }}</div>
      </div>
    </div>
  </div>

<!--  <div class="text-end p-3 d-flex justify-content-between">
    <button class="btn btn-secondary btn-sm" (click)="onClose()">Kapat</button>
    <button
      *ngIf="selectedUserId !== null"
      class="btn btn-primary btn-sm"
      (click)="confirmSelection()">
      Tamam
    </button>
  </div>-->

  <ng-template pTemplate="footer">
    <button class="btn btn-secondary btn-sm" (click)="onClose()">Kapat</button>
    <button
      *ngIf="selectedUserId !== null"
      class="btn btn-primary btn-sm"
      (click)="confirmSelection()">
      Tamam
    </button>
  </ng-template>
</p-dialog>
<app-loading
  [fullScreen]="false"
  [loading]="loading ?? false"
></app-loading>
